/**
 * ★★ I18N-01 — LE SEUL POINT QUI APPREND LA LANGUE DU THÉÂTRE AU CODE
 *              NON-REACT.
 *
 * `lib/format.ts` doit connaître la langue pour écrire « Donnerstag » plutôt
 * que « jeudi », et il n'est pas un composant : il ne peut pas appeler
 * `useTheatre()`. `lib/langue.ts` expose donc `enregistrerLangueDuTheatre()`,
 * et **ce composant est son unique appelant**.
 *
 * ★ Il ne rend rien. C'est délibéré : un composant qui n'affiche rien mais
 *   qui synchronise deux mondes se repère et se retire d'un seul geste, là où
 *   un `useEffect` posé dans la coque se serait dilué dans quinze autres.
 *
 * ⚠️ **Il se monte HAUT et une seule fois.** Deux instances ne casseraient
 *    rien (l'enregistrement est idempotent et court-circuite quand la valeur
 *    ne change pas), mais elles diraient que personne ne sait plus où la
 *    langue est décidée — ce qui est le début du défaut que tout ce lot
 *    referme.
 */

import { useEffect } from 'react'

import { enregistrerLangueDuTheatre } from './langue'
import { useTheatre } from './theatre'

export function LangueDuTheatre({ actif = true }: { readonly actif?: boolean }): null {
  const { langue } = useTheatre(actif)

  useEffect(() => {
    /* `null` est une valeur légitime, pas une absence à ignorer : sur la
       vitrine, il DIT qu'aucun théâtre ne décide, et c'est ce qui rend la
       main au navigateur du visiteur. */
    enregistrerLangueDuTheatre(actif ? langue : null)
  }, [actif, langue])

  return null
}
